export default __webpack_public_path__ + "static/media/call.676beec3.svg";